import { UserInterface } from '../interfaces';
import { createTableColumns } from '../utils';

import Axios from "../libraries/axios";

class UserModel implements UserInterface {
  [key: string]: any
  _id = '';
  email = '';
  password = '';
  role = '';
  createdAt = new Date();
  updatedAt = new Date();

  constructor(props: UserInterface) {
    if (props) {
      Object.assign(this, props);
    }
  }

  static getColumns() {
    return createTableColumns(['email', 'role']);
  }

  static async fetchAll<ReturnType>(
    params: any = {},
    config: any = {}
  ): Promise<ReturnType> {
    try {
      const { data } = await Axios.get('/users', {
        params,
        ...config,
      });

      return data;
    } catch (e: any) {
      throw new Error(e);
    }
  }

  static async create(
    user: UserInterface
  ): Promise<any> {
    try {
      const { data } = await Axios.post('/users', user);
      return data;
    } catch (e: any) {
      throw new Error(e);
    }
  }

  static async update(
    id: string,
    user: UserInterface
  ): Promise<any> {
    try {
      const { data } = await Axios.patch(`/users/${id}`, user);
      return data;
    } catch (e: any) {
      throw new Error(e);
    }
  }

  static async delete(
    id: string,
  ): Promise<any> {
    try {
      const { data } = await Axios.delete(`/users/${id}`);
      return data;
    } catch (e: any) {
      throw new Error(e);
    }
  }
}

export default UserModel;
